const container = document.getElementById('container');

const gridTopCenter = document.getElementById('gridTopCenter');
const gridBottomCenter = document.getElementById('gridBottomCenter');
const gridTopLeft = document.getElementById('gridTopLeft');
const gridTopRight = document.getElementById('gridTopRight');
const gridBottomRight = document.getElementById('gridBottomRight');
const gridBottomLeft = document.getElementById('gridBottomLeft');

const updateGridlines = () => {
    if (window.innerWidth > 1024) {
        const windowWidth = window.innerWidth;
        const containerWidth = container.offsetWidth;
        const gridWidth = ((windowWidth - containerWidth) / 2) + 26;

        const widthEls = [gridTopLeft, gridTopRight, gridBottomLeft, gridBottomRight];
        widthEls.forEach(el => el.style.width = `${ gridWidth - 12 }px`);

        const gridTopCenterHeight = gridTopCenter.offsetHeight;
        const gridBottomCenterHeight = gridBottomCenter.offsetHeight;
        gridBottomCenter.width = gridTopCenter.offsetWidth;

        [gridTopLeft, gridTopRight].forEach(el => el.style.height = `${ gridTopCenterHeight }px`);
        [gridBottomLeft, gridBottomRight].forEach(el => el.style.height = `${ gridBottomCenterHeight }px`);
    }
};

window.addEventListener('resize', updateGridlines);

export default function standardHerosInit() {
    updateGridlines();
}
